import { applyClassName, styled, type StyledComponent, type StyledElementProps } from '@glitz/react';
import * as React from 'react';
import { isNordicNest, SiteTheme } from 'webapp/theme';
import chatSvg from '../../../../../../src/components/icons/generic/chat.svg';
import homeHeartSvg from '../../../../../../src/components/icons/generic/home.svg';
import orderSvg from '../../../../../../src/components/icons/generic/order.svg';
import shareSvg from '../../../../../../src/components/icons/generic/share.svg';
import birdOneSvg from './glyphs/bird-1.svg';
import birdTwoSvg from './glyphs/bird-2.svg';
import birdThridSvg from './glyphs/bird-3.svg';
import birdFourSvg from './glyphs/bird-4.svg';
import birdFiveSvg from './glyphs/bird-5.svg';
import celebration from './glyphs/celebration.svg';
import lsChatSvg from './glyphs/chat-ls.svg';
import nnChatSvg from './glyphs/chat.svg';
import { default as chevronDown, default as nnChevronDown } from './glyphs/chevron-down.svg';
import { default as chevronRight, default as nnChevronRight } from './glyphs/chevron-right.svg';
import facebookSvg from './glyphs/facebook.svg';
import lsHeartSvg from './glyphs/heart-ls.svg';
import homeSvg from './glyphs/home.svg';
import instagramSvg from './glyphs/instagram.svg';
import lineArrowLeftSvg from './glyphs/line-arrow-left.svg';
import birdsnestSvg from './glyphs/membership-icons.svg';
import DownloadSvg from './glyphs/nn-icon-download.svg';
import flagCNSvg from './glyphs/nn-icon-flags-CN.svg';
import flagDESvg from './glyphs/nn-icon-flags-DE.svg';
import flagDKSvg from './glyphs/nn-icon-flags-DK.svg';
import flagESSvg from './glyphs/nn-icon-flags-ES.svg';
import flagFISvg from './glyphs/nn-icon-flags-FI.svg';
import flagFRSvg from './glyphs/nn-icon-flags-FR.svg';
import flagGBSvg from './glyphs/nn-icon-flags-GB.svg';
import flagGRSvg from './glyphs/nn-icon-flags-GR.svg';
import flagITSvg from './glyphs/nn-icon-flags-IT.svg';
import flagJPSvg from './glyphs/nn-icon-flags-JP.svg';
import flagKRSvg from './glyphs/nn-icon-flags-KR.svg';
import flagNLSvg from './glyphs/nn-icon-flags-NL.svg';
import flagNOSvg from './glyphs/nn-icon-flags-NO.svg';
import flagPLSvg from './glyphs/nn-icon-flags-PL.svg';
import flagPTSvg from './glyphs/nn-icon-flags-PT.svg';
import flagSESvg from './glyphs/nn-icon-flags-SE.svg';
import quoteSvg from './glyphs/quote.svg';
import resetSvg from './glyphs/reset.svg';
import shippingBirdSvg from './glyphs/shipping-bird.svg';
import lsUserSvg from './glyphs/user-ls.svg';
interface IconMap {
  [key: string]: React.FunctionComponent<React.SVGAttributes<SVGElement>>;
}

export function normalize(Icon: React.FunctionComponent<StyledElementProps>) {
  return styled(applyClassName(Icon), {
    display: 'block',
    height: '1.5em',
    width: '1.5em',
  });
}

export const HomeIcon = normalize(isNordicNest ? homeSvg : homeHeartSvg);

const chatIcon: IconMap = {
  [SiteTheme.NordicNest]: nnChatSvg,
  [SiteTheme.Kitchentime]: chatSvg,
  [SiteTheme.Lightshop]: lsChatSvg,
};

export const ChatIcon = (props: any) => {
  const svg = chatIcon[__SITE__] || chatSvg;
  const Icon = normalize(svg);
  return <Icon {...props} />;
};

export const FacebookIcon = normalize(facebookSvg);

export const InstagramIcon = normalize(instagramSvg);

export const ResetIcon = normalize(resetSvg);

export const QuoteIcon = normalize(quoteSvg);

export const ChevronRightIcon = normalize(isNordicNest ? nnChevronRight : chevronRight);

export const ChevronDownIcon = normalize(isNordicNest ? nnChevronDown : chevronDown);

export const CelebrationIcon = normalize(celebration);

export const OrderIcon = normalize(orderSvg);

export const StandingBirdIcon = styled(applyClassName(birdOneSvg), {
  display: 'block',
  height: 49,
  width: 29,
});

export const BentBirdIcon = styled(applyClassName(birdTwoSvg), {
  display: 'block',
  height: 43,
  width: 46,
});

export const SittingBirdIcon = styled(applyClassName(birdThridSvg), {
  display: 'block',
});

export const SecondaryStandingBirdIcon = styled(applyClassName(birdFourSvg), {
  display: 'block',
});

export const BentBirdWithBranchIcon = styled(applyClassName(birdFiveSvg));

export const ShippingBirdIcon = styled(applyClassName(shippingBirdSvg), {
  display: 'block',
  height: 72,
  width: 72,
});

export const BirdsnestIcons = styled(applyClassName(birdsnestSvg));

export const LineArrowLeft = normalize(lineArrowLeftSvg);

export const DownloadIcon = normalize(isNordicNest ? DownloadSvg : shareSvg);

export const flagDE = normalize(flagDESvg);

export const flagDK = normalize(flagDKSvg);

export const flagES = normalize(flagESSvg);

export const flagFI = normalize(flagFISvg);

export const flagFR = normalize(flagFRSvg);

export const flagGB = normalize(flagGBSvg);

export const flagKR = normalize(flagKRSvg);

export const flagNL = normalize(flagNLSvg);

export const flagNO = normalize(flagNOSvg);

export const flagSE = normalize(flagSESvg);

export const flagPL = normalize(flagPLSvg);

export const flagJP = normalize(flagJPSvg);

export const flagIT = normalize(flagITSvg);

export const flagGR = normalize(flagGRSvg);

export const flagPT = normalize(flagPTSvg);

export const flagCN = normalize(flagCNSvg);

export function getCurrentFlag(language: string): StyledComponent<React.SVGAttributes<SVGElement>> {
  switch (language) {
    case 'de-DE':
      return flagDE;
    case 'da-DK':
      return flagDK;
    case 'es-ES':
      return flagES;
    case 'fi-FI':
      return flagFI;
    case 'fr-FR':
      return flagFR;
    case 'en-US':
      return flagGB;
    case 'ko-KR':
      return flagKR;
    case 'nl-NL':
      return flagNL;
    case 'nb-NO':
      return flagNO;
    case 'sv-SE':
      return flagSE;
    case 'pl-PL':
      return flagPL;
    case 'ja-JP':
      return flagJP;
    case 'it-IT':
      return flagIT;
    case 'el-GR':
      return flagGR;
    case 'pt-PT':
      return flagPT;
    case 'zh-CN':
      return flagCN;
    default:
      return styled(() => null);
  }
}
